var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.buyMethods),function(buyMethod,idx){return _c('order-buy-method-item',_vm._g(_vm._b({key:idx,attrs:{"buy-method":buyMethod},on:{"change":_vm.handleChange}},'order-buy-method-item',_vm.$attrs,false),_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }